<ng-content select="emperor-icon:not(.icon-suffix)"></ng-content>
<ng-content></ng-content>

<div class="emperor-ui-chip-container">
  <ng-content select="emperor-chip"></ng-content>
</div>

<ng-content select=".icon-suffix"></ng-content>
